import React from "react";
import "./styles.css";

export default ({ text }) => (
  <div className="fx-container-x fx-align-centre">
    <div className="afs-msm-divider-line fx-grow" />
    <span className="afs-msm-divider-text">{text}</span>
    <div className="afs-msm-divider-line fx-grow" />
  </div>
);
